import React, { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "features/auth/hooks/useAuth";
import { useAdminFlags } from "hooks/useAdminFlags";
import { FullScreenLoader } from "components/ui/Loader";

// Where a signed-in account without admin rights is sent.
export const ADMIN_DENIED_PATH = "/no-access";

interface Props {
  children: ReactNode;
}

const AdminRoute: React.FC<Props> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const { loading: flagsLoading, isAdmin, isSuperadmin } = useAdminFlags();
  const location = useLocation();

  if (authLoading || flagsLoading) {
    return <FullScreenLoader label="Checking admin…" />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const allowed = isAdmin || isSuperadmin;
  if (!allowed) {
    return <Navigate to={ADMIN_DENIED_PATH} replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
